import { render, staticRenderFns } from "./GalleryShowMore.vue?vue&type=template&id=332c7c93&scoped=true"
import script from "./GalleryShowMore.vue?vue&type=script&lang=ts"
export * from "./GalleryShowMore.vue?vue&type=script&lang=ts"
import style0 from "./GalleryShowMore.vue?vue&type=style&index=0&id=332c7c93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c7c93",
  null
  
)

export default component.exports